(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.invest-dialog-unexpected-error', ['pp.widgets-templates']);

ngModule.component('ppInvestDialogUnexpectedError', {
    templateUrl: 'widgets/_angular/invest-dialog-unexpected-error/invest-dialog-unexpected-error.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', function ($scope) {
        var vm = this;

        // -- initial state

        // -- util functions

        // -- api

        // -- scope bindings

        // -- main

    }]
});
})(window, window.angular);